module.exports = __webpack_public_path__ + "static/media/map.02560a4e.png";